<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Gwalior One Day Open Rapid Chess Tournament</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial Gwalior One Day Open Rapid Chess Tournament</span></h2>
        </div>

        <p><strong>Date: </strong>21 June 2026</p>
        <p><strong>Venue: </strong>Mahaveer Bhavan, Nai Sadak, Gwalior, Madhya Pradesh</p>
        <p><strong>Organized By: </strong>All Gwalior Chess Association</p>
        <p><strong>In Association with: </strong>G.H. Raisoni Sports and Cultural Foundation & Kalpana Prakash Welfare
            Foundation</p>
        <p><strong>Total Prize Fund: </strong>₹51,000</p>

        <p>The G.H. Raisoni Memorial Gwalior One Day Open Rapid Chess Tournament 2026 was successfully conducted on
            21 June 2026 at Mahaveer Bhavan, Nai Sadak, Gwalior, Madhya Pradesh. The tournament was conducted by the
            All Gwalior Chess Association in association with the G.H. Raisoni Sports and Cultural Foundation and
            Kalpana Prakash Welfare Foundation.</p>
        <p>The event received an overwhelming response with 218 players from six districts of Madhya Pradesh
            participating in a 7-round Swiss System Rapid tournament conducted under FIDE and AICF regulations with a
            time control of 15 minutes + 5 seconds increment per move. The championship featured a ₹51,000 prize
            fund, with the winner receiving ₹8,000.</p>
        <p>The event was graced by CDR Deepak Singh Bhadoria, Commanding Officer, 3MP Naval Unit NCC, Gwalior, as the
            Chief Guest, along with Dr. Garima Garg, Tournament Director and President of the All Gwalior Chess
            Association. The tournament was efficiently managed under the leadership of IA Narapuram V.R. Sreehari,
            Chief Arbiter, supported by an experienced team of arbiters, ensuring fair play and the smooth conduct of
            all seven rounds.</p>
        <p>The successful execution of the tournament, enthusiastic participation, and positive feedback from players
            and officials made the event a remarkable celebration of competitive chess and further strengthened the
            commitment of the organizing associations towards promoting chess across the region.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tournament-report-gwalior.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
